// ===================================
// FOOTER CONTACT FORM HANDLER - FRONTEND
// Profesional handler para el formulario de contacto rápido en el footer
// ===================================

// Importa el sistema de notificaciones
import { notifications } from "./notifications.js";

class FooterContactFormManager {
  constructor() {
    this.form = null;
    this.submitBtn = null;
    this.btnText = null;
    this.btnLoading = null;
    this.messageContainer = null;
    this.isSubmitting = false;
  }

  init() {
    this.form = document.getElementById("footer-contact-form");
    this.submitBtn = document.getElementById("footer-submit-btn");
    this.btnText = document.getElementById("footer-btn-text");
    this.btnLoading = document.getElementById("footer-btn-loading");
    this.messageContainer = document.getElementById("footer-contact-message");

    if (!this.form) return;

    this.form.addEventListener("submit", (e) => this.handleSubmit(e));
    const inputs = this.form.querySelectorAll("input, textarea");
    inputs.forEach((input) => {
      input.addEventListener("blur", () => this.validateField(input));
      input.addEventListener("input", () => this.clearFieldError(input));
    });
  }

  validateField(field) {
    const value =
      field.type === "checkbox" ? field.checked : field.value.trim();
    let isValid = true;
    let errorMessage = "";

    if (field.hasAttribute("required") && !value) {
      isValid = false;
      errorMessage = "This field is required";
    } else if (field.type === "email" && value) {
      isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value.trim());
      if (!isValid) errorMessage = "Please enter a valid email address";
    }

    this.showFieldError(field, isValid, errorMessage);
    return isValid;
  }

  showFieldError(field, isValid, message) {
    field.classList.toggle("border-red-500", !isValid);
    field.classList.toggle("border-green-500", isValid && field.value.trim());
    field.classList.toggle("border-gray-300", isValid && !field.value.trim());

    let errorElement = field.parentNode.querySelector(".field-error");
    if (!isValid && message) {
      if (!errorElement) {
        errorElement = document.createElement("div");
        errorElement.className = "field-error text-red-500 text-xs mt-1";
        errorElement.textContent = message;
        field.parentNode.appendChild(errorElement);
      } else {
        errorElement.textContent = message;
      }
    } else if (errorElement) {
      errorElement.remove();
    }
  }

  clearFieldError(field) {
    field.classList.remove("border-red-500");
    const errorElement = field.parentNode.querySelector(".field-error");
    if (errorElement) errorElement.remove();
  }

  validateForm() {
    const requiredFields = this.form.querySelectorAll("[required]");
    let isFormValid = true;
    requiredFields.forEach((field) => {
      if (!this.validateField(field)) isFormValid = false;
    });
    return isFormValid;
  }

  collectFormData() {
    const formData = new FormData(this.form);
    return {
      name: formData.get("name")?.trim(),
      email: formData.get("email")?.trim(),
      message: formData.get("message")?.trim(),
      consent: this.form.querySelector("#footerConsent")?.checked || false,
      submission_time: new Date().toISOString(),
      user_agent: navigator.userAgent,
      referrer: document.referrer,
      page_url: window.location.href,
      timestamp: Date.now(),
    };
  }

  setLoadingState(isLoading) {
    this.submitBtn.disabled = isLoading;
    this.btnText.style.display = isLoading ? "none" : "inline";
    this.btnLoading.style.display = isLoading ? "inline" : "none";
    if (isLoading) {
      this.submitBtn.classList.add("opacity-75", "cursor-not-allowed");
    } else {
      this.submitBtn.classList.remove("opacity-75", "cursor-not-allowed");
    }
  }

  showMessage(message, type = "success") {
    // Toast en la esquina superior derecha
    notifications.show(message, type);

    if (!this.messageContainer) return;
    this.messageContainer.style.display = "block";
    this.messageContainer.className =
      "p-2 mb-3 rounded text-sm transition-all duration-300 " +
      (type === "success"
        ? "bg-green-50 text-green-800 border border-green-200"
        : "bg-red-50 text-red-800 border border-red-200");
    this.messageContainer.textContent = message;
  }

  clearMessage() {
    if (this.messageContainer) {
      this.messageContainer.style.display = "none";
      this.messageContainer.textContent = "";
    }
  }

  //   async handleSubmit(e) {
  //     e.preventDefault();
  //     if (this.isSubmitting) return;
  //     this.clearMessage();

  //     if (!this.validateForm()) {
  //       this.showMessage(
  //         "Please fix the errors above before submitting.",
  //         "error"
  //       );
  //       return;
  //     }

  //     this.isSubmitting = true;
  //     this.setLoadingState(true);

  //     try {
  //       const data = this.collectFormData();
  //       // Puedes cambiar la URL a tu endpoint real si es necesario
  //       const response = await fetch("/contact", {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({
  //           first_name: data.name,
  //           last_name: "",
  //           email: data.email,
  //           phone: "",
  //           subject: "Quick Message",
  //           message: data.message,
  //         }),
  //       });
  //       const result = await response.json();

  //       if (result.success) {
  //         this.showMessage(
  //           "Thank you for your message! We will contact you soon.",
  //           "success"
  //         );
  //         this.form.reset();
  //         const fields = this.form.querySelectorAll("input, textarea");
  //         fields.forEach((field) => {
  //           this.clearFieldError(field);
  //           field.classList.remove("border-green-500");
  //           field.classList.add("border-gray-300");
  //         });
  //       } else {
  //         this.showMessage(
  //           result.message || "Message not sent. Please try again.",
  //           "error"
  //         );
  //       }
  //     } catch (error) {
  //       this.showMessage(
  //         "Unable to send your message right now. Please try again or contact us directly at +51-982-373-883",
  //         "error"
  //       );
  //     } finally {
  //       this.isSubmitting = false;
  //       this.setLoadingState(false);
  //     }
  //   }
  async handleSubmit(e) {
    e.preventDefault();
    if (this.isSubmitting) return;
    this.clearMessage();

    if (!this.validateForm()) {
      this.showMessage(
        "Please fix the errors above before submitting.",
        "error"
      );
      return;
    }

    this.isSubmitting = true;
    this.setLoadingState(true);

    try {
      const formData = new FormData(this.form);
      // Si tu backend espera "name", "email", "message", "subject", "next_", "honey"
      // y tu HTML tiene esos campos, puedes enviar el FormData directamente

      const response = await fetch("/footer-contact", {
        method: "POST",
        body: formData, // <-- ENVÍA COMO FORM DATA
      });
      const result = await response.json();

      if (result.success) {
        this.showMessage(
          "Thank you for your message! We will contact you soon.",
          "success"
        );
        this.form.reset();
        const fields = this.form.querySelectorAll("input, textarea");
        fields.forEach((field) => {
          this.clearFieldError(field);
          field.classList.remove("border-green-500");
          field.classList.add("border-gray-300");
        });
      } else {
        this.showMessage(
          result.message || "Message not sent. Please try again.",
          "error"
        );
      }
    } catch (error) {
      this.showMessage(
        "Unable to send your message right now. Please try again or contact us directly at +51-982-373-883",
        "error"
      );
    } finally {
      this.isSubmitting = false;
      this.setLoadingState(false);
    }
  }
}

// Export singleton instance
export const footerContactFormManager = new FooterContactFormManager();
export default footerContactFormManager;
